export enum ObjectEventEnum {
    "onBlur" = "onBlur",
    "onChange" = "onChange"
  }